import React from "react";
import {
  NumberInput,
  RadioInput,
  SelectInput,
} from "../../components/common/ui/Inputs";
import { useDispatch, useSelector } from "react-redux";
import { facilityAction } from "../../_store";
import { facilitySchema } from "../../validation/facilitySchema";

function ConnectionRequestSetup({ errorMessage, setErrorMessage }) {
  const dispatch = useDispatch();
  const { Status, facilityFrequencyType } = useSelector(
    (state) => state.dropdownOptions
  );
  const facilityInformationData = useSelector((x) => x?.facility?.facilityData);

  // Replace first object label 
  const updatedFacilityFrequencyType = facilityFrequencyType.map((role, index) => {
    if (index === 0) {
      return { ...facilityFrequencyType, label: "-- Select --", value: 0 }; // Replace the label of the first object
    }
    return role;
  });

  const handleChange = async (e, input) => {
    let facilityData = { ...facilityInformationData };
    if (input) {
      facilityData[input] = e?.value ? e?.value : 0;
      try {
        // Clear error if validation passes
        setErrorMessage((prev) => ({
          ...prev,
          [input]: "", // Clear the specific field error
        }));
        let inputData = { [input]: e?.value ? e?.value : 0 }
        // Validate the field using the Joi schema and handle both required and other validation
        await facilitySchema.validateAsync(
          {
            ...inputData,
            "IsInmateInvitePublic": facilityData?.IsInmateInvitePublic
          },
          { abortEarly: false }
        );
      } catch (err) {
        // Find the error that matches the current field name
        const fieldError = err.details.find((error) => error.path.includes(input));

        if (fieldError) {
          setErrorMessage((prev) => ({
            ...prev,
            [input]: fieldError.message, // Set the specific field error from Joi
          }));
        }
      }
    } else {
      const { name, value } = e.target;
      facilityData[name] = parseInt(value);
    }
    dispatch(facilityAction.setFacilityData(facilityData));
  };

  const handleBlurConnectionRequest = async (e) => {
    let facilityData = { ...facilityInformationData };
    let { name, value } = e.target;
    try {
      // Clear error if validation passes
      setErrorMessage((prev) => ({
        ...prev,
        [name]: "", // Clear the specific field error
      }));
      let inputData = { [name]: value }
      // Validate the field using the Joi schema and handle both required and other validation
      await facilitySchema.validateAsync(
        {
          ...inputData,
          "IsInmateInvitePublic": facilityData?.IsInmateInvitePublic
        },
        { abortEarly: false }
      );
    } catch (err) {
      const fieldError = err.details.find((error) => error.path.includes(name));

      if (fieldError) {
        setErrorMessage((prev) => ({
          ...prev,
          [name]: fieldError.message, // Set the specific field error from Joi
        }));
      }
    }
  };


  return (
    <div className="mt-3 mb-3">
      <h4 className=" inner-header-bg text-color" style={{ cursor: "pointer" }} title="">
        <i class="fa-solid fa-user-gear me-2"></i>Connection Request Setup
      </h4>
      <div className="row mb-4">
        <div className="col-sm-12 col-md-6 col-lg-3">
          <div className="form-floating mb-3">
            <SelectInput
              id="InmateInvitePublicFrequencyType"
              name="InmateInvitePublicFrequencyType"
              options={updatedFacilityFrequencyType}
              isMulti={false}
              closeMenuOnSelect={true}
              isDisabled={false}
              isLoading={false}
              isClearable={facilityInformationData?.InmateInvitePublicFrequencyType !== 0}
              label="Frequency"
              placeholder="Select Credit"
              value={facilityInformationData?.InmateInvitePublicFrequencyType}
              handleChange={(e) =>
                handleChange(e, "InmateInvitePublicFrequencyType")
              }
              required
              errorMessage={errorMessage}
            />
          </div>
        </div>

        <div className="col-sm-12 col-md-6 col-lg-3">
          <div className="form-floating mb-3">
            <NumberInput
              name="InmateInvitePublicCount"
              id="InmateInvitePublicCount"
              label="Limit"
              value={facilityInformationData?.InmateInvitePublicCount}
              handleChange={handleChange}
              placeholder="Enter Limit"
              required
              errorMessage={errorMessage}
              handleBlur={handleBlurConnectionRequest}
              maxLength={3}
            //maxValue={100}
            />
          </div>
        </div>

        <div className="col-sm-12 col-md-6 col-lg-3">
          <div className="form-floating mb-3">
            <NumberInput
              name="InmateInvitePublicRepeatLimit"
              id="InmateInvitePublicRepeatLimit"
              label="Limit Per Source (Per Month)"
              value={facilityInformationData?.InmateInvitePublicRepeatLimit}
              handleChange={handleChange}
              placeholder="Enter Limit"
              required
              errorMessage={errorMessage}
              handleBlur={handleBlurConnectionRequest}
              maxLength={3}
            //maxValue={100}
            />
          </div>
        </div>

        <div className="col-sm-12 col-md-6 col-lg-3">
          <div className="form-floating mb-3">
            <RadioInput
              label="Status"
              // id="InmateInvitePublicActiveStatus"
              // options={Status}
              name="InmateInvitePublicActiveStatus"
              id="Status"
              options={Status}
              errorMessage={errorMessage}
              handleChange={(e) => handleChange(e)}
              selectedValue={
                facilityInformationData?.InmateInvitePublicActiveStatus
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default React.memo(ConnectionRequestSetup);
